module.exports = __webpack_public_path__ + "static/media/21ECLAC15.1925599f.jpg";